<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="StrategyID">
          <a-input placeholder="Please enterStrategyID" v-decorator="[ 'id', validatorRules.id]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Strategy Set ID">
          <a-input placeholder="Please enter strategy set ID" v-decorator="[ 'strategyId', validatorRules.strategyId]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Feature ID">
          <a-input placeholder="Please enter feature ID" v-decorator="[ 'featuresId', validatorRules.featuresId]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Execution Sequence">
          <a-input placeholder="Please enter execution sequence" v-decorator="[ 'sortNum', validatorRules.sortNum]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Intersection Identifier">
          <a-input placeholder="Intersection Identifier:id1_id2_id3" v-decorator="[ 'andGroup']"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Calculation Rule">
          <a-input placeholder="Calculation Rule:true,false,[-Inf,0)U(0,Inf]U[missing]"
                   v-decorator="[ 'rule', validatorRules.rule]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Valid">
          <a-input placeholder="0:Valid,1:Delete" v-decorator="[ 'isDel', validatorRules.isDel]"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import {editRiskRule} from '@/webpublicapi/risk'

// duplicateCheck
export default {
  name: 'DictModal',
  data() {
    return {
      value: 1,
      title: 'Action',
      allowPrepay: 1,
      productId: '',
      visibleCheck: true,
      visible: false,
      model: {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 5}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16}
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        id: {rules: [{required: true, message: 'Please enterStrategyID!'}]},
        strategyId: {
          rules: [{required: true, message: 'Please enter strategy set ID!'}]
        },
        featuresId: {
          rules: [{required: true, message: 'Please enter feature ID!'}]
        },
        sortNum: {rules: [{required: true, message: 'Please enter execution sequence!'}]},
        rule: {rules: [{required: true, message: 'Please enter calculation rule!'}]},
        isDel: {rules: [{required: true, message: 'Please enterValid Identifier!'}]},


      }

    }
  },
  created() {
  },
  methods: {
    add(proId, ssId) {
      this.productId = proId
      this.appSsid = ssId
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      if (record.id) {
        this.allowPrepay = record.allowPrepay
        this.visibleCheck = (record.allowPrepay == 1)
      }
      this.visible = true;
      const data = pick(this.model, 'id', 'strategyId', 'featuresId', 'sortNum', 'andGroup', 'rule', 'isDel');
      data.allowPrepay = !!data.allowPrepay;
      this.$nextTick(() => {
        this.form.setFieldsValue(data);
      })
    },
    onChose(checked) {
      if (checked) {
        this.allowPrepay = 1
        this.visibleCheck = true
      } else {
        this.allowPrepay = 0
        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk() {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          formData.allowPrepay = +formData.allowPrepay ? 1 : 0;
          let obj = editRiskRule(formData)

          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok')
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    // Close
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
